import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import DXSelectFilter from '../DXSelectFilter/DXSelectFilter';
import DXFilterConfig from '../DXFilterConfig';
import constants from '../../constants';

const propTypes = {
  equality: PropTypes.string,
  selected: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {
  selected: [],
};

class DXSubscriptionPaymentTypeFilter extends React.Component {
  render() {
    const { selected, onChange, intl, equality } = this.props;
    const config = DXSubscriptionPaymentTypeFilter.getConfig(intl, equality);
    return (
      <DXSelectFilter
        selected={selected}
        title={config.title}
        values={config.values}
        onChange={onChange}
        multi={config.multi}
      />
    );
  }
}

DXSubscriptionPaymentTypeFilter.propTypes = propTypes;
DXSubscriptionPaymentTypeFilter.defaultProps = defaultProps;
DXSubscriptionPaymentTypeFilter.getLabel = (intl, selectedValues) => {
  return DXSelectFilter.getLabel(intl, 'filter.paymentTypes.', selectedValues);
};
DXSubscriptionPaymentTypeFilter.applyToQueryParams = (queryParams, selectedValues, filter) => {
  const param = !!filter?.queryParams?.paymentTypes?.default ? filter.queryParams.paymentTypes.default : 'paymentTypes';

  queryParams[param] = selectedValues;
  return queryParams;
};
DXSubscriptionPaymentTypeFilter.getConfig = (intl, equality, queryParamsByFilterName) => {
  let config = new DXFilterConfig({
    name: 'paymentTypes',
    selected: [],
    property: 'paymentTypes',
    title: intl.formatMessage({ id: 'filter.paymentTypes' }),
    disabled: false,
    equalityStatus: false,
    multi: true,
    queryParams: queryParamsByFilterName,
  });

  if (equality === constants.FILTER_EQUALITY_EQUALS) {
    config.addFilterValue('upfront', intl.formatMessage({ id: 'filter.paymentTypes.upfront' }));
    config.addFilterValue('recurring', intl.formatMessage({ id: 'filter.paymentTypes.recurring' }));
  }

  return config;
};

DXSubscriptionPaymentTypeFilter.getInitialConfig = (intl, values, readOnly, invisible) => {
  return {
    name: 'paymentTypes',
    title: intl.formatMessage({ id: 'filter.paymentTypes' }),
    property: 'paymentTypes',
    type: 'paymentTypes',
    selectedValues: values,
    clientSide: false,
    readOnly: readOnly ? readOnly : false,
    fromVariable: !!invisible || false,
  };
};

export default injectIntl(DXSubscriptionPaymentTypeFilter);
